import axios from 'axios';

const RESOURCE_NAME = '/startup/trackers';

export default {
    getTrackersForApply(filters) {
        return axios.post(`${RESOURCE_NAME}/get-trackers-for-apply`, filters)
    },

    checkApplicationStatus(id) {
        return axios.get(`${RESOURCE_NAME}/check-application-status?id=${id}`)
    },

    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`)
    },

    getQuestions(id) {
        return axios.get(`${RESOURCE_NAME}/get-questions?id=${id}`)
    },

    apply(id, data) {
        return axios.post(`${RESOURCE_NAME}/apply?id=${id}`, data)
    },

    saveFiles(trackerId, fieldId, data) {
        return axios.post(`${RESOURCE_NAME}/save-files?id=${trackerId}&field_id=${fieldId}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
    },
}